// src/unicodex_ui/components/FooterBar.jsx
import React from "react";
import "../styles/FooterBar.css";

function FooterBar() {
  const year = new Date().getFullYear();

  return (
    <footer className="ucx-footer">
      <div className="ucx-container ucx-footer-inner">
        <div className="ucx-footer-left">
          <span>
            UNI-CODEX &copy; <span>{year}</span>
          </span>
          <span className="ucx-footer-dot">•</span>
          <span>Universal Anti-Counterfeit Identity &amp; Verification</span>
        </div>
        <div className="ucx-footer-right">
          <a href="/docs" className="ucx-footer-link">
            Technical Docs
          </a>
          <a href="/apply" className="ucx-footer-link">
            Become a Registered Manufacturer
          </a>
        </div>
      </div>
    </footer>
  );
}

export default FooterBar;
